import styled from '@app/styled';
import { color, mediaQuery, spacing } from '@app/theme';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: ${spacing(6)};
    position: absolute;
    padding: ${spacing(7, 12)};
    right: 0;
    left: 0;
    // to make logout above sidebar
    z-index: 2;

    ${mediaQuery.max('sm')} {
        padding: ${spacing(7, 7)};
        gap: unset;
    }
`;

export const LogoutButton = styled.a`
    color: #808080;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
        color: ${color('custom.interactive.primary.idle')};
    }

    &:focus {
        color: ${color('custom.interactive.primary.idle')};
    }
`;
